'use strict';

var React = require('react');
var index_es$1 = require('./index.es-55fa6858.js');
var index_es = require('./index.es-8c72aff8.js');
var styled = require('styled-components');
var Text = require('@swiggy-private/dls-web-core/dist/components/Text');
var FullWidthButton = require('@swiggy-private/dls-web-core/dist/components/FullWidthButton');
var WidgetController_widgets_CTAButtonWidget_type = require('./WidgetController/widgets/CTAButtonWidget/type.js');
var WidgetControllerContext = require('./WidgetControllerContext-924d4968.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const PLACEHOLDERS = {
    DEL_TAG_START: "<del>",
    DEL_TAG_END: "</del>",
};
const CONSTANT_HTTP_HEADERS = {
    marketplacecategory: "FOOD",
    "x-web-checkout-flow": "payment",
    marketplaceid: "1",
    marketplaceBusinessLine: "swiggy_super",
    quantity: "1",
    postpaymentredirectionlink: "",
};
const ANALYTICS_EVENT = {
    IMPRESSION: "impression-cta-button-widget",
    CLICK: "click-cta-button-widget",
};
const DATA_TEST_IDS = {
    CONTAINER: "cta-button-widget-container-{0}",
    CTA: "cta-button-widget",
};

const CTAContainer = styled__default['default'].div(({ theme }) => ({
    margin: `0 ${theme.spacing.medium} ${theme.spacing.large} ${theme.spacing.medium}`,
    height: "auto",
}));
const CTATextNode = styled__default['default'](Text.Text)(() => ({
    display: "inline-block",
}));
const CTADelTextNode = styled__default['default'](Text.Text)(() => ({
    display: "inline-block",
    textDecoration: "line-through",
}));
const FullWidthButtonCTA = styled__default['default'](FullWidthButton.FullWidthButton)(({ theme }) => ({
    height: "auto",
    padding: `${theme.spacing.small} ${theme.spacing.medium}`,
}));

const isValidCTATypeForDeeplinkNav = (type) => {
    return [WidgetController_widgets_CTAButtonWidget_type.CTAType.PLAN_PURCHASE, WidgetController_widgets_CTAButtonWidget_type.CTAType.DEEPLINK].includes(String(type).toUpperCase());
};
const analyticsContextDataCreator = (text = "", subText = "", planId, cta) => {
    return {
        text,
        subText,
        planId,
        ctaType: (cta === null || cta === void 0 ? void 0 : cta.type) || "-",
    };
};
const textToReactNode = (text) => {
    if (index_es.N(text))
        return null;
    if (text.includes(PLACEHOLDERS.DEL_TAG_START) && text.includes(PLACEHOLDERS.DEL_TAG_END)) {
        const [preText, delTag] = text.split(PLACEHOLDERS.DEL_TAG_START);
        const [delTagText, postText] = delTag.split(PLACEHOLDERS.DEL_TAG_END);
        return (React__default['default'].createElement(CTATextNode, { variant: "button_Text_BT2", color: "background_Primary" },
            preText,
            !index_es.N(delTagText) && (React__default['default'].createElement(CTADelTextNode, { variant: "subheader_S1_Reg", color: "background_Primary" }, delTagText)),
            postText));
    }
    return text;
};
const getA11YText = (text = "", subText = "") => {
    if (index_es.N(text))
        return "";
    if (text.includes(PLACEHOLDERS.DEL_TAG_START) && text.includes(PLACEHOLDERS.DEL_TAG_END)) {
        const [preText, delTag] = text.split(PLACEHOLDERS.DEL_TAG_START);
        const [, postText] = delTag.split(PLACEHOLDERS.DEL_TAG_END);
        return `${preText === null || preText === void 0 ? void 0 : preText.trim()} ${postText === null || postText === void 0 ? void 0 : postText.trim()} ${subText === null || subText === void 0 ? void 0 : subText.trim()}`;
    }
    return `${text} ${subText}`.trim();
};
const buildHTTPHeadersForPayments = (planId, headers) => {
    var _a;
    return Object.assign(Object.assign(Object.assign({}, headers), CONSTANT_HTTP_HEADERS), { "user-agent": ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) || "", planid: String(planId) });
};

const CTAButtonWidget = ({ text, subText, cta, planDetails, position }) => {
    const planId = !index_es.N(planDetails) ? planDetails === null || planDetails === void 0 ? void 0 : planDetails[0].planId : "";
    const { impressionAnalytics, clickAnalytics, sdk, headers } = React.useContext(WidgetControllerContext.WidgetControllerContext);
    const contextObjectForAnalytics = React.useMemo(() => analyticsContextDataCreator(text, subText, String(planId), cta), [cta, planId, subText, text]);
    React.useEffect(() => {
        if (!index_es.N(impressionAnalytics)) {
            impressionAnalytics({
                action: ANALYTICS_EVENT.IMPRESSION,
                value: position,
                context: contextObjectForAnalytics,
            });
        }
    }, [impressionAnalytics, position, contextObjectForAnalytics]);
    const clickHandler = React.useCallback(() => {
        if (!index_es.N(clickAnalytics)) {
            clickAnalytics({
                action: ANALYTICS_EVENT.CLICK,
                value: position,
                context: contextObjectForAnalytics,
            });
        }
        let httpHeaders;
        if (isValidCTATypeForDeeplinkNav(cta === null || cta === void 0 ? void 0 : cta.type) && !index_es.N(cta === null || cta === void 0 ? void 0 : cta.link)) {
            if (String(cta === null || cta === void 0 ? void 0 : cta.type).toUpperCase() === WidgetController_widgets_CTAButtonWidget_type.CTAType.PLAN_PURCHASE &&
                !index_es.N(planId) &&
                !index_es.N(headers)) {
                httpHeaders = buildHTTPHeadersForPayments(planId, headers);
            }
            sdk === null || sdk === void 0 ? void 0 : sdk.navigateToScreen({
                type: index_es$1.N.DEEPLINK,
                link: cta === null || cta === void 0 ? void 0 : cta.link,
                httpHeaders,
            });
        }
        else {
            sdk === null || sdk === void 0 ? void 0 : sdk.close();
        }
    }, [clickAnalytics, cta, position, contextObjectForAnalytics, planId, headers, sdk]);
    const reactNodeText = React.useMemo(() => textToReactNode(text), [text]);
    const a11yText = React.useMemo(() => getA11YText(text, subText), [text, subText]);
    const dataTestId = React.useMemo(() => index_es.O(DATA_TEST_IDS.CONTAINER, String(cta === null || cta === void 0 ? void 0 : cta.type).toLowerCase()), [cta]);
    if (index_es.N(reactNodeText))
        return null;
    return (React__default['default'].createElement(CTAContainer, { "data-testid": dataTestId },
        React__default['default'].createElement(FullWidthButtonCTA, { "aria-label": a11yText, onClick: clickHandler, "data-testid": DATA_TEST_IDS.CTA, subLabel: subText, variant: "primary" }, reactNodeText)));
};
var CTAButtonWidget$1 = React__default['default'].memo(CTAButtonWidget);

exports.CTAButtonWidget = CTAButtonWidget$1;
//# sourceMappingURL=CTAButtonWidget-562b2404.js.map
